<template lang="html">
    <div>
        <Heading :title="$t('account_activate_header')" :routeName="'vignette'"></Heading>
        <div class="container pb-4">
            <div class="text-center alert" v-bind:class="{'alert-success': status == 1, 'alert-info': status == 0, 'alert-danger': status == -1}">
                <van-loading v-if="!status">{{message}}</van-loading>
                <template v-if="status">
                    {{message}}
                </template>
            </div>
            <template v-if="status > 0">
                <LoginComponent :hide-socials="true"></LoginComponent>
            </template>
        </div>
    </div>
</template>

<script>

import Heading from './../snippets/Heading.vue'
import LoginComponent from '../authentication/LoginComponent.vue'

export default {
    name: 'AccountActivate',
    components: {
        Heading,
        LoginComponent
    },
    data: function() {
        return {
            message: this.$t('account_activate_message'),
            status: 0
        }
    },
    props: ['token'],
    mounted: function() {
        this.activateAccount();
    },
    methods: {
        async activateAccount() {
            try {
                let response = await this.$axios.get('/activate_user/' + this.token);
                this.message = response.data.message;
                this.status = 1;
            }
            catch(error) {
                this.message = error.response.data.error.error_msg;
                this.status = -1;
            }
        }
    }
}
</script>

<style lang="scss" scoped>

    $lightgrey: lightgrey;
    $green: #59af54;

</style>
